import axios from "axios";
import { deriveErrorMessage } from "libLegacy/internal/deriveErrorMessage";
import { User } from "./models";
import { UserMe, UserProfile } from "api/authTypes";

export const fetchUserMe = async (token: string) => {
  return axios
    .get<User>(`${process.env.REACT_APP_API_PATH}/users/profile/me`, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((e) => {
      const err = deriveErrorMessage(e, "usr1");
      return Promise.reject(new Error(err));
    });
};

export const updateUser = async (
  token: string,
  user: Partial<UserMe & UserProfile>
) => {
  return axios
    .put<User>(`${process.env.REACT_APP_API_PATH}/users`, user, {
      headers: {
        Authorization: token,
      },
    })
    .then((data) => data)
    .catch((e) => {
      const err = deriveErrorMessage(e, "usr8");
      return Promise.reject(new Error(err));
    });
};
